export const sources={avif:"__VITE_ASSET__DEs8BD0L__ 80w"};export const img={src:"__VITE_ASSET__Bv3fuo0x__",w:80,h:33};export default{sources:sources,img:img};